import { LinearProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import React, { Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PWAPrompt from 'react-ios-pwa-prompt';
import { renderRoutes } from 'react-router-config';
import NavBar from './NavBar';
import TopBar from './TopBar';
import { useOfflineDashboardDataCacher } from 'src/contexts/OfflineDashboardContext';

const useStyles = makeStyles((theme) => ({
  container: {
    minHeight: '100vh',
    display: 'flex',
    '@media all and (-ms-high-contrast:none)': {
      height: 0 // IE11 fix
    }
  },
  content: {
    paddingTop: 0,
    flexGrow: 1,
    maxWidth: '100%',
    overflowX: 'hidden',
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 256,
      paddingTop: 10
    },
    [theme.breakpoints.down('xs')]: {
      paddingTop: 50
    }
  }
}));

function Dashboard({ route }) {
  const classes = useStyles();
  const { t } = useTranslation('common');
  const [openNavBarMobile, setOpenNavBarMobile] = useState(false);
  useOfflineDashboardDataCacher()

  return (
    <>
      <TopBar onOpenNavBarMobile={() => setOpenNavBarMobile(true)} />
      <NavBar
        onMobileClose={() => setOpenNavBarMobile(false)}
        openMobile={openNavBarMobile}
      />
      <div className={classes.container}>
        <div className={classes.content}>
          <PWAPrompt
            promptOnVisit={1}
            timesToShow={3}
            copyTitle={t('Ana_ekrana_ekle')}
            copyBody={t('pwa_prompt1')}
            copyShareButtonLabel={t('pwa_prompt2')}
            copyAddHomeButtonLabel={t('pwa_prompt3')}
            copyClosePrompt={t('Kapat')}
            permanentlyHideOnDismiss={false}
          />
          <Suspense fallback={<LinearProgress />}>
            {renderRoutes(route.routes)}
          </Suspense>
        </div>
      </div>
    </>
  );
}

Dashboard.propTypes = {
  route: PropTypes.object
};

export default Dashboard;
